<template>
  <div>
    <!-- <h1>Tabela de ocorrências de/para</h1>
    <br />-->
    <h1>Ocorrências entrega</h1>

    <b-row>
      <b-table
        ref="selectableTable"
        id="table-tabela-proceda"
        hover
        :items="itemsTabelaProceda"
        :fields="fieldsTabelaProceda"
        :per-page="perPage"
        :current-page="currentPage"
      >
        <template v-slot:cell(selected)="{ rowSelected }">
          <template v-if="rowSelected">
            <span aria-hidden="true">&check;</span>
            <span class="sr-only">Selected</span>
          </template>
          <template v-else>
            <span aria-hidden="true">&nbsp;</span>
            <span class="sr-only">Not selected</span>
          </template>
        </template>
        <!-- <template v-slot:cell(id)="data">
        <router-link :to="'/usuario/edit/' + data.value">{{ data.value }}</router-link>
        </template>-->
      </b-table>
    </b-row>

    <b-row>
      <b-col sm="4" md="4" lg="4">
        <b-pagination
          v-model="currentPage"
          :total-rows="rows"
          :per-page="perPage"
          first-number
          last-number
          aria-controls="table-tabela-proceda"
        ></b-pagination>
      </b-col>
      <b-col sm="4" md="4" lg="4">
        <label
          for="perPageSelect"
        >Exibindo {{ paginationFrom }} até {{ paginationTo }} de um total de {{rows}}</label>
      </b-col>
      <b-col sm="4" md="4" lg="4">
        <b-row>
          <b-col sm="3" md="3" lg="3">
            <b-form-select v-model="perPage" id="perPageSelect" size="sm" :options="pageOptions"></b-form-select>
          </b-col>
          <b-col style="padding-left: 0px;">
            <label for="perPageSelect">registros exibidos por página</label>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <!-- <p>
      Selected Rows:
      <br />
      {{ selectedTabelaProceda }}
    </p>-->
  </div>
</template>

<script>
import AwesomeMask from "awesome-mask";
//import ListEntregaOcorrencia from "./components/entregaOcorrencia/List";
// ListEntregaOcorrencia

export default {
  name: "ListEntregaOcorrencia",
  props: {
    id: String,
  },
  data: function () {
    return {
      fieldsTabelaProceda: [
        {
          label: "Embarcador",
          key: "embarcador.razaoSocial",
          sortable: true,
        },
        {
          label: "Transportador",
          key: "transportador.razaoSocial",
          sortable: true,
        },
        {
          label: "Data de ocorrencia",
          key: "dataOcorrencia",
          sortable: true,
        },
        {
          label: "Código PROCEDA",
          key: "ocorrenciaProceda.codigo",
          sortable: true,
        },
        {
          label: "Descrição PROCEDA",
          key: "ocorrenciaProceda.descricao",
          sortable: true,
        },
        {
          label: "Código EDI",
          key: "codigoOcorrencia",
          sortable: true,
        },
      ],
      itemsTabelaProceda: [],
      perPage: 10,
      pageOptions: [5, 10, 25, 50, 100, 150],
      currentPage: 1,
      selectModeTabelaProceda: "single",
      selectedTabelaProceda: [],
    };
  },
  computed: {
    rows() {
      return this.itemsTabelaProceda.length;
    },
    paginationFrom() {
      return this.perPage * (this.currentPage - 1) + 1;
    },
    paginationTo() {
      let to = this.paginationFrom - 1 + this.perPage;
      if (to > this.rows) return this.rows;
      return to;
    },
  },
  created: function () {
    this.loadDataTabelaProceda();
  },
  directives: {
    mask: AwesomeMask,
  },
  methods: {
    async loadDataTabelaProceda() {
      console.log("/entregaOcorrencia/entrega/" + this.id);
      this.$api
        .get("/entregaOcorrencia/entrega/" + this.id)
        .then((response) => {
          this.itemsTabelaProceda = response.data;
        })
        .catch((err) => {
          console.log(err);
          console.log(err.response);
          if (err.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          }
        });
    },
  },
};
</script>

<style>
table tr {
  white-space: normal;
}
</style>